import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  /* max-width: 650px; */
  margin: 10px auto;
  text-align: center;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px; 
  overflow: hidden;
  display: flex;
  flex-flow: column;
  min-height: 70vh;
  position: relative;
`

export const Content = styled.div`
  border: 3px solid black;
  border-radius: 5px;
  box-shadow: -4px 0px 10px gray;
  margin: 0 10px;
  flex: 1 1 auto; 
  margin-bottom: -2px;
  margin-right: 30px;
  
`

export const Header = styled.div`
  width: 100%;
  margin-bottom: -0px;
  flex: 0 1 auto;


  img {
    width: 55%;
    height: auto;
  }
`

export const StickFooter = styled.div`
  text-align: center;
  flex: 0 1 40px;
`

export const List = styled.ul`
  list-style: none;
  padding: 0;

  li {
    padding: 10px;
    border-bottom: 1px solid #ccc;
    display: flex;

    p {
      flex: 1;
      text-align: left;
    }

    &:first-child {
      padding: 20px 10px;
      font-size: large;
      color: #073014;
      border-bottom: 1px solid gray;
    }
    
    &:last-child {
      border-bottom: none;
    }

    &:not(:first-child) {
      font-family: 'Playwrite US Trad', sans-serif !important;
      font-size: 14px;
    }

  }  
`

export const Title = styled.div`
  font-size: xx-large;
  border-bottom: 1px solid gray;
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
  gap: 10px;
  color: #073014;
  box-shadow: 1px 1px 3px gray;
  margin-bottom: -11px;

  .title-description {
    flex: 1;

    span {
      vertical-align: center;
    }
  }

  img {
    border-radius: 5px;
    height: auto;
    max-width: 100px;
  }
`

export const PenImage = styled.div`
  position: absolute;
  right: -3px;
  bottom: 65px;

  img {
    width: 50%;
    height: auto;
  }
`